import { render } from "./initializedDeliveryOrdersList.vue?vue&type=template&id=84d9224c&scoped=true"
import script from "./initializedDeliveryOrdersList.vue?vue&type=script&lang=js"
export * from "./initializedDeliveryOrdersList.vue?vue&type=script&lang=js"

import "./initializedDeliveryOrdersList.vue?vue&type=style&index=0&id=84d9224c&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84d9224c"]])

export default __exports__